import React from "react";
import { Component } from "react";
import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ControlSelect, ControlText, ControlTextarea } from "../../../../common/custom-form/control-field.component";
import { CustomDropdown } from "../../../../common/custom-form/custom-dropdown.component";
import { inventoryCircuitEquipActions } from "../../../../../store/external/reports-reducer/inventory/details-view/add-equipment.reducer";
import {
    ACTION_TYPES, Selected_Index, EQUIPMENT_TYPE, MAX_LENGTH, DATA_TYPE, REQUEST_TYPES_ID, ORDER_EQUIPMENT_STATUS
} from "../../../../../constants/external-constants";
import { InputFieldFloatingLabel as InputField } from "../../../../common/custom-form/select-filter.component";
import Translation from "../../../../../components/common/translation/translation.component";
import { ConfirmationNotificationModal } from "../../../../common/modal/confirmation-modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import TableWithButton from "../../../../common/details-table/table-with-button.component";
import { assignDefaultIfEmptyString, hasObjectWithProperty, isDisabledPerRequestType } from "../../../../../utils/helpers.utils";
import { TRANSLATIONS } from '../../../../../utils/constant.utils';
import CustomSearchableDropdownWrapper from "../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class AddEquipment extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            updateEquipDetails: false,
            activeDropdown: false,
            showDetails: false,
            showModal: false,
            showNotif: false,
            notifTitle: null,
            tableLength: 0,
            isUpdate: false,
            ignoreTypeIdReset: false
        }
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;

        const {
            circuitId, vendorId, getCircuitEquipList,
            isCircuitOrder, equipementTableLength, circuitTypeID
        } = this.props;

        if (isCircuitOrder != undefined && isCircuitOrder != null && isCircuitOrder == true) {
            if (this._isMounted) {
                this.setState({ tableLength: equipementTableLength });
            }
        }
        else {
            getCircuitEquipList(circuitId, vendorId, circuitTypeID).then(() => {
                if (this._isMounted) { 
                    const { circuitEquipList } = this.props.inventoryCircuitEquip;
                    const tableLength = circuitEquipList?.datatable[0]?.dataItem?.length;
                    this.setState({ tableLength });
                }
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {
            circuitId, vendorId, circuitTypeID, getCircuitEquipList,
            getCircuitOrderEquipList, requestTypeId, orderDetailsId, OrderCircuitDetailId,
            isCircuitOrder, billingAccountID, inventoryCircuitEquipForm, onServiceModelSelect
        } = this.props;

        let isCircuitOrderSelected = isCircuitOrder != undefined && isCircuitOrder != null && isCircuitOrder == true;
        let isVendorIdUpdated = this.props.vendorId !== prevProps.vendorId && circuitTypeID !== 0;
        let isCircuitTypeUpdated = this.props.circuitTypeID !== prevProps.circuitTypeID && vendorId !== 0;
        let isBillingAccountUpdated = billingAccountID !== prevProps.billingAccountID && vendorId !== 0;

        const { ignoreTypeIdReset, lastTypeId } = this.state;

        const prevTypeId = prevProps.inventoryCircuitEquipForm?.TypeId;
        const currentTypeId = inventoryCircuitEquipForm?.TypeId;

        if (!ignoreTypeIdReset && prevTypeId != null && prevTypeId !== currentTypeId && lastTypeId !== currentTypeId) {
            onServiceModelSelect('inventoryCircuitEquipForm.ModelId', null);
            this.props.getDeviceModels(vendorId, circuitTypeID, 1, '');
            this.props.getAccessoryModels(vendorId, circuitTypeID, 1, '');
            this.setState({ lastTypeId: currentTypeId });
        }

        // Inventory Circuit Detail
        if (!isCircuitOrderSelected) {
            if (isVendorIdUpdated || isCircuitTypeUpdated) {
                getCircuitEquipList(circuitId, vendorId, circuitTypeID).then(() => {
                });
            }
        }
        // Order Circuit Detail
        else {
            if (isCircuitTypeUpdated || isBillingAccountUpdated) {
                getCircuitOrderEquipList(vendorId, orderDetailsId, requestTypeId, OrderCircuitDetailId, circuitTypeID).then(() => { });
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        const { resetCircuitEquipForm, resetCircuitEquipDetails } = this.props;
        resetCircuitEquipForm();
        resetCircuitEquipDetails();
    }

    showDetails(value) {
        this.setState({
            showDetails: value
        });
    };

    onClickCancel = () => {
        const { resetCircuitEquipForm } = this.props;
        this.toggleActiveState();
        resetCircuitEquipForm();

        this.setState({
            updateEquipDetails: false
        });
    };

    onRowClick = async (index) => {
        const { viewCircuitEquipItem, vendorId, circuitTypeID, inventoryCircuitEquipForm, inventoryCircuitEquip } = this.props;
        this.setState({ ignoreTypeIdReset: true });
        this.toggleActiveState();
        await viewCircuitEquipItem(index);
        this.isActiveDropDownState();

        this.setState({ ignoreTypeIdReset: true }, async () => {
            const model = inventoryCircuitEquipForm.Model ?? inventoryCircuitEquip?.circuitEquipList?.datatable[0]?.dataItem[0].Model;
                await this.props.getDeviceModels(vendorId, circuitTypeID, 1, model);
                await this.props.getAccessoryModels(vendorId, circuitTypeID, 1, model);
  
            this.setState({ updateEquipDetails: true, activeDropdown: true, ignoreTypeIdReset: false });
        });
    };

    isActiveDropDownState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    };

    updateCircuitEquip = () => {
        const { updateCircuitEquipItem, resetCircuitEquipForm, toggleDropdown, isCircuitOrder } = this.props;
        updateCircuitEquipItem();
        if (!isCircuitOrder) {
            toggleDropdown(Selected_Index.i_Six);
        }
        resetCircuitEquipForm();
        this.toggleActiveState(false);

        this.setState({
            updateEquipDetails: false,
            notifTitle: 'updated'
        });
    };

    addCircuitEquip = () => {
        const { addCircuitEquipItem, resetCircuitEquipForm, toggleDropdown } = this.props;

        addCircuitEquipItem();
        if (toggleDropdown)
        {
            toggleDropdown(Selected_Index.i_Six);
        }
        resetCircuitEquipForm();
        this.toggleActiveState(false);
    };

    onClickAdd = () => {

        this.setState({
            showModal: true,
            notifTitle: 'added'
        });
    };
    toggleActiveState = () => {
        const { isCircuitOrder, requestTypeId } = this.props;
        const noAddFunction = isCircuitOrder && (parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.subscriptionCancellation) || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.portOut)); 
        const isOtherRequest = parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.other) || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeNumber)  
                                || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.simActivation) || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.enableHotspot)
                                || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.suspendResumeService) || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.wirelineChangeVendor)
                                || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.pukCode) || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherSIMReplacement) 
                                || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherChangeOfPlan);

        this.setState({ isUpdate: false });

        if (isCircuitOrder && this.hasExistingEquipment() && (!isOtherRequest || noAddFunction)) {
            this.setState({ activeDropdown: false });
        }
        else {
            this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
        }
    };

    handleConfirmationModal = (buttonType) => {
        if (buttonType === "ok") {
            this.state.updateEquipDetails ? this.updateCircuitEquip() : this.addCircuitEquip();
            this.props.handleChangesStatus('equipmentChange', true);
            this.setState( prev => ({
                showModal: false,
                showNotif: false
            }))
        }
        else {
            this.setState({
                showModal: false
            });
        }
    };

    hasExistingEquipment = () => {
        const { circuitEquipList } = this.props.inventoryCircuitEquip;
        return circuitEquipList?.datatable?.[0]?.dataItem?.length > 0 || false;
    };

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    };

    handleOpenNotif = () => {
        this.setState({
            showNotif: true,
            notifTitle: 'deleted'
        });
    };

    isUpdateButtonEnabled = (state, form, circuitList) => {
        // Extract relevant properties from the objects
        const { updateEquipDetails } = this.state;
        const { requestTypeId } = this.props;
        const {
            TypeId, ModelId, IMEISerialNumber, StatusId,
            Price, ID, AssetTagNumber, ProductName,
            PartCode, AdditionalInformation
        } = form;
        const dataItem = circuitList.datatable[0]?.dataItem[ID];

        if (updateEquipDetails) {
            const isIMEIRequired = Number(TypeId) === EQUIPMENT_TYPE.Device ? IMEISerialNumber : true;
            const isStatusRequired = Number(requestTypeId) === REQUEST_TYPES_ID.accessory ? StatusId : true;
            const hasValidPrice = Price !== null && Price !== undefined && Price !== '';
            const isFormValid = TypeId && ModelId && isIMEIRequired && isStatusRequired && hasValidPrice;
            const hasChanged = (
                Number(dataItem?.TypeId) !== Number(TypeId) ||
                Number(dataItem?.ModelId) !== Number(ModelId) ||
                Number(dataItem?.StatusId) !== Number(StatusId) ||
                assignDefaultIfEmptyString(dataItem?.IMEISerialNumber, null) !== assignDefaultIfEmptyString(IMEISerialNumber, null) ||
                assignDefaultIfEmptyString(dataItem?.AssetTagNumber, null) !== assignDefaultIfEmptyString(AssetTagNumber, null) ||
                dataItem?.ProductName !== ProductName ||
                assignDefaultIfEmptyString(dataItem?.PartCode, null) !== assignDefaultIfEmptyString(PartCode, null) ||
                dataItem?.Price !== Price ||
                assignDefaultIfEmptyString(dataItem?.AdditionalInformation, null) !== assignDefaultIfEmptyString(AdditionalInformation, null)
            );
            return isFormValid && hasChanged;
        }
        return false;
    };

    deleteCircuitEquipItem = (index) =>{
        const {deleteCircuitEquipItem, handleChangesStatus} = this.props;
        const { circuitEquipList } = this.props.inventoryCircuitEquip;

        deleteCircuitEquipItem(index);

        const updatedCircuitEquipList = circuitEquipList;

        let newTable = updatedCircuitEquipList?.datatable[0]?.dataItem;

        newTable.splice(index, 1);

        handleChangesStatus('equipmentChange', true);


        const containsObjectWithID = hasObjectWithProperty(newTable, "ID", -1);

        if(containsObjectWithID || this.state.tableLength !== newTable.length){
            handleChangesStatus('equipmentChange', true);
        }else{
            handleChangesStatus('equipmentChange', false);

        }
    };

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return TRANSLATIONS[locale][key];
    };

    handleModelSearch = async (query) => {
        const { vendorId, circuitTypeID } = this.props;

        await this.props.getDeviceModels(vendorId, circuitTypeID, 1, query);
        await this.props.getAccessoryModels(vendorId, circuitTypeID, 1, query);
    }

    loadMoreModels = async (searchString) => {
        const { vendorId, circuitTypeID, inventoryCircuitEquip } = this.props;

        await this.props.getDeviceModels(vendorId, circuitTypeID, inventoryCircuitEquip.deviceModelsPage + 1, searchString);
        await this.props.getAccessoryModels(vendorId, circuitTypeID, inventoryCircuitEquip.accessoryModelsPage + 1, searchString);
    }

    render() {
        const { inventoryCircuitEquipForm, onServiceModelSelect, translator, hasPendingApproval, isCircuitOrder, requestTypeId, completed, isCreateNew } = this.props;
        const { circuitEquipList, equipTypes, equipDevices, equipAccessories, equipStatuses, hasMoreDeviceModels, hasMoreAccessoryModels, isDeviceModelsLoading, isAccessoryModelsLoading } = this.props.inventoryCircuitEquip;
        const hasExistingEquipment = this.hasExistingEquipment();
        
        const noAddFunction = isCircuitOrder && (parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.subscriptionCancellation)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.portOut)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.intlRoamingAccess)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.terminateSubscriptionWireline)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.CallingAccess));

        const isOtherRequest = parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.other)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeNumber)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.simActivation)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.enableHotspot)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.suspendResumeService)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.pukCode)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherSIMReplacement)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherChangeOfPlan);


        const isRequestRequired = parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeVendor)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.updatePlanWireline)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.newSubscriptionWireline)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.wirelineChangeVendor)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.wirelineUpgradeCircuit)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.wirelineChangeLocationAddress);

        const isDevice = Number(inventoryCircuitEquipForm.TypeId) === EQUIPMENT_TYPE.Device;
        const isIMEIRequired = isDevice ? inventoryCircuitEquipForm.IMEISerialNumber : true;
        const isStatusRequired = !requestTypeId ? inventoryCircuitEquipForm.StatusId : (isRequestRequired || isOtherRequest || isCreateNew) ? inventoryCircuitEquipForm.StatusId : true;
        const enableAddBtn = inventoryCircuitEquipForm.TypeId && inventoryCircuitEquipForm.ModelId && isIMEIRequired && isStatusRequired && inventoryCircuitEquipForm.Price;

        const sectionTitle = (hasExistingEquipment && isCircuitOrder && !isOtherRequest) || noAddFunction
            ? <Translation translationKey="equipment" />
            : <Translation translationKey="add_equipment" />;

        const isRequestContainsSelectedEquipStatus = parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeVendor);

        const isEquipmentPriceRequired = parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeVendor)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeNumber)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.enableHotspot)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.other)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.simActivation)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.suspendResumeService)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.pukCode)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherSIMReplacement)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherChangeOfPlan);

        const equipmentStatuses = equipStatuses && isRequestContainsSelectedEquipStatus ? equipStatuses.filter(e => e.FilterId === ORDER_EQUIPMENT_STATUS.inService 
            || e.FilterId === ORDER_EQUIPMENT_STATUS.outOfService) : equipStatuses;   

        return (
            <>
                <NotificationModal
                    show={this.state.showNotif}
                    title={'Success'}
                    message={`Sim circuit ${this.state.notifTitle} successfully!`}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer'}
                />
                <CustomDropdown activeDropdown={this.state.activeDropdown} toggleActiveState={this.toggleActiveState} label={sectionTitle}>
                    <div className={`add-equipment-container detail-page-container details-4-col-container`}>
                        <ControlSelect
                            label={<Translation translationKey="equipment_type" />}
                            options={equipTypes}
                            model="inventoryCircuitEquipForm.TypeId"
                            isRequired={isRequestRequired || !isDisabledPerRequestType(requestTypeId, 'TypeId')}
                            value={inventoryCircuitEquipForm.TypeId}
                            placeholder={isDisabledPerRequestType(requestTypeId, 'TypeId') ? '' : `${translator("select_placeholder")}`}
                            disabled={completed || isDisabledPerRequestType(requestTypeId, 'TypeId')}
                        />
                        <CustomSearchableDropdownWrapper
                            label={this.toLocaleLanguage("model_upper")}
                            options={parseInt(inventoryCircuitEquipForm.TypeId) === parseInt(EQUIPMENT_TYPE.Device) ? equipDevices : (parseInt(inventoryCircuitEquipForm.TypeId) === parseInt(EQUIPMENT_TYPE.Accessory) ? equipAccessories : [])}
                            selected={inventoryCircuitEquipForm.ModelId}
                            onChange={(e) => onServiceModelSelect('inventoryCircuitEquipForm.ModelId', e)}
                            placeholder={isDisabledPerRequestType(requestTypeId, 'ModelId') ? '' : `${translator('select_placeholder')}`}
                            fieldProp='inventoryCircuitEquipForm.ModelId'
                            isMainFilter={true}
                            isNullable={true}
                            isRequiredButNullable={isRequestRequired || !isDisabledPerRequestType(requestTypeId, 'ModelId')}
                            optionLabelKey={{
                                Key: 'FilterId',
                                Value: 'FilterName',
                                Label: 'FilterName'
                            }}
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={completed || isDisabledPerRequestType(requestTypeId, 'ModelId')}
                            onSearchChange={this.handleModelSearch}
                            onLoadMore={this.loadMoreModels}
                            isLoading={
                                Number(inventoryCircuitEquipForm.TypeId) === EQUIPMENT_TYPE.Device
                                    ? isDeviceModelsLoading
                                    : Number(inventoryCircuitEquipForm.TypeId) === EQUIPMENT_TYPE.Accessory
                                        ? isAccessoryModelsLoading
                                        : false
                            }
                            hasMore={
                                Number(inventoryCircuitEquipForm.TypeId) === EQUIPMENT_TYPE.Device
                                    ? hasMoreDeviceModels
                                    : Number(inventoryCircuitEquipForm.TypeId) === EQUIPMENT_TYPE.Accessory
                                        ? hasMoreAccessoryModels
                                        : false
                            }
                        />
                        <ControlText
                            label={<Translation translationKey="imei_serial_no_upper" />}
                            model="inventoryCircuitEquipForm.IMEISerialNumber"
                            isRequired={(isDevice && !isDisabledPerRequestType(requestTypeId, 'IMEISerialNumber'))}
                            value={inventoryCircuitEquipForm.IMEISerialNumber}
                            placeholder={isDisabledPerRequestType(requestTypeId, 'IMEISerialNumber') ? '' : `${translator("enter_text_placeholder")}`}
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={completed || isDisabledPerRequestType(requestTypeId, 'IMEISerialNumber')}
                        />
                        <ControlText
                            label={<Translation translationKey="asset_tag_num_upper" />}
                            model="inventoryCircuitEquipForm.AssetTagNumber"
                            value={inventoryCircuitEquipForm.AssetTagNumber}
                            placeholder={isDisabledPerRequestType(requestTypeId, 'AssetTagNumber') ? '' : `${translator("enter_text_placeholder")}`}
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={completed || isDisabledPerRequestType(requestTypeId, 'AssetTagNumber')}
                        />
                        <ControlSelect
                            label={<Translation translationKey="status_capital" />}
                            isRequired={!requestTypeId ? true : isRequestRequired || isOtherRequest}
                            disabled={completed ||  isDisabledPerRequestType(requestTypeId, 'StatusId')}
                            options={equipmentStatuses}
                            model="inventoryCircuitEquipForm.StatusId"
                            value={inventoryCircuitEquipForm.StatusId}
                            placeholder={completed || isDisabledPerRequestType(requestTypeId, 'StatusId') ? '' : `${translator("select_placeholder")}`}
                        />
                        <ControlText
                            label={<Translation translationKey="product_name" />}
                            model="inventoryCircuitEquipForm.ProductName"
                            value={inventoryCircuitEquipForm.ProductName}
                            placeholder={isDisabledPerRequestType(requestTypeId, 'ProductName') ? '' : `${translator("enter_text_placeholder")}`}
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={completed || isDisabledPerRequestType(requestTypeId, 'ProductName')}
                        />
                        <ControlText
                            label={<Translation translationKey="part_code" />}
                            model="inventoryCircuitEquipForm.PartCode"
                            value={inventoryCircuitEquipForm.PartCode}
                            placeholder={isDisabledPerRequestType(requestTypeId, 'PartCode') ? '' : `${translator("enter_text_placeholder")}`}
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={completed || isDisabledPerRequestType(requestTypeId, 'PartCode')}
                        />
                        <InputField
                            className={`form-control ${!isDisabledPerRequestType(requestTypeId, 'Price') && !(isEquipmentPriceRequired) ? 'required': ''}`}
                            type="text"
                            label={<Translation translationKey="price_upper" />}
                            value={inventoryCircuitEquipForm.Price}
                            fieldProp='inventoryCircuitEquipForm.Price'
                            inputType={DATA_TYPE.decimal}
                            maxLength={MAX_LENGTH.inputText}
                            disabled={completed || isDisabledPerRequestType(requestTypeId, 'Price')}
                            isRequired={!isDisabledPerRequestType(requestTypeId, 'Price')}
                        />
                        <ControlTextarea
                            label={<Translation translationKey="additional_information" />}
                            model="inventoryCircuitEquipForm.AdditionalInformation"
                            colClassName="details-container-full-row"
                            value={inventoryCircuitEquipForm.AdditionalInformation}
                            placeholder={isDisabledPerRequestType(requestTypeId, 'AdditionalInformation') ? '' : `${translator("enter_text_placeholder")}`}
                            maxLength={MAX_LENGTH.limit_255}
                            disabled={completed || isDisabledPerRequestType(requestTypeId, 'AdditionalInformation')}
                        />
                        {!isDisabledPerRequestType(requestTypeId, 'equipmentActionBtn') ?
                            <div className="add-button-container custom-add-button">
                                {!noAddFunction &&
                                    <div className="btn-tooltiptext">
                                        <Button onClick={this.onClickCancel} className="btn-custom-violet-hover-outline">Cancel</Button>
                                        <span className="tooltip-text">{this.state.updateEquipDetails ? this.toLocaleLanguage("cancel_update_equipment_details") : this.toLocaleLanguage("cancel_add_equipment_details")}</span>
                                    </div>
                                }
                                <ConfirmationNotificationModal
                                    show={this.state.showModal}
                                    message={this.state.updateEquipDetails ? 'Are you sure you want to update?' : 'Are you sure you want to add?'}
                                    title={this.state.updateEquipDetails ? 'Update' : 'Add'}
                                    handleModal={this.handleConfirmationModal}
                                    customClass={'comment-notification-modal modal-text-bold'}
                                />
                                {!noAddFunction &&
                                    <div className={'btn-tooltiptext'}>
                                        <Button
                                            className="btn-add"
                                            disabled={(this.props.isReadOnly || this.props.isReadAndExtractOnly) ? true : hasPendingApproval ? hasPendingApproval :
                                                (this.state.updateEquipDetails ? !this.isUpdateButtonEnabled(this.state, inventoryCircuitEquipForm, circuitEquipList) : !enableAddBtn)}
                                            onClick={this.onClickAdd}>{`${this.state.updateEquipDetails ? ACTION_TYPES.Update : ACTION_TYPES.Add}`}
                                        </Button>
                                        <span className="tooltip-text">{this.state.updateEquipDetails ? this.toLocaleLanguage("update_equipment_details") : this.toLocaleLanguage("add_equipment_details") }</span>
                                    </div>
                                }
                            </div>
                            : null
                        }
                    </div>
                </CustomDropdown>
                {
                    hasExistingEquipment &&
                    <div className="details-table-container add-equipment-container">
                        <TableWithButton
                            classNameWrapper="table-details-wrapper table-clickable"
                            datatable={circuitEquipList.datatable}
                            haveExternalDeleteBtn={this.props.IsReadOnly ? false : (this.props.isReadAndExtractOnly ? false : (this.props.isReadAndWrite ? true : false))}
                            deleteAction={(index) => this.deleteCircuitEquipItem(index)}
                            rowClickAction={this.onRowClick}
                            handleOpenNotif={this.handleOpenNotif}
                            hideDeleteBtn={this.props.hideDeleteBtn || isDisabledPerRequestType(requestTypeId, 'deleteEquipment')}
                            handleCloseNotif={this.handleCloseNotif}
                        />
                    </div>
                }
            </>
        )
    }
}

export default connect(
    state => {
        const { inventoryCircuitEquip, translation } = state;
        const { inventoryCircuitEquipForm } = state.form;
        return {
            inventoryCircuitEquip
            , inventoryCircuitEquipForm
            , ...translation
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryCircuitEquipActions),
        dispatch
    )
)(AddEquipment);